import React, { useState } from "react";
import {
  Box,
  IconButton,
  Typography,
  Divider,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PatientInfoTabs from "./PatientInfoTabs";
import PatientObservations from "./PatientObservations";
import TaskAssignedModal from "./TaskAssignedModal";

const LayPatientModal = ({ open, onClose, selectedPatientId }) => {
  const [openTaskModal, setOpenTaskModal] = useState(false);

  // Lista mock de empleados (puedes traerla de contexto o servicio)
  const employeeList = [
    { id: 101, name: "Dr. Sandra Vega" },
    { id: 102, name: "Nurse John Carter" },
    { id: 103, name: "Therapist Laura Kim" },
  ];

  const handleAssignTask = (taskData) => {
    console.log("✅ Task assigned: ", taskData);
    // Aquí podrías llamar a un contexto, API, etc.
  };

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1300,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          position: "relative",
          width: "95%",
          maxWidth: "1100px",
          height: "90%",
          backgroundColor: "background.paper",
          borderRadius: 4,
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 2,
            backgroundColor: "primary.main",
            color: "white",
            height: "60px",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            🧑‍⚕️ Patient Details
          </Typography>
          <IconButton onClick={onClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Cuerpo dividido */}
        <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
          {/* Tabs (izquierda) */}
          <Box sx={{ flex: 1, p: 2, overflowY: "auto" }}>
            <PatientInfoTabs
              selectedPatientId={selectedPatientId}
              onAssignTask={() => setOpenTaskModal(true)}
              onClick={onClose}
            />
          </Box>

          <Divider orientation="vertical" flexItem />

          {/* Observaciones (derecha) */}
          <Box sx={{ flex: 1, p: 2, overflowY: "auto" }}>
            <PatientObservations cipId={selectedPatientId} />
          </Box>
        </Box>
      </Paper>

      {/* Modal de asignación de tareas */}
      <TaskAssignedModal
        open={openTaskModal}
        onClose={() => setOpenTaskModal(false)}
        cipId={selectedPatientId}
        employeeList={employeeList}
        onAssign={handleAssignTask}
      />
    </Box>
  );
};

export default LayPatientModal;
